import { useTranslation } from "react-i18next";
import {
  CloseOutlined,
  InfoCircleOutlined,
  SaveOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Col,
  Drawer,
  Flex,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { isEmpty } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import ReactQuill from "react-quill";
import { FORMAT_REACT_QUILL } from "../../../constants";
import { multimediaIconList } from "../../../constants/multimedia-constants/multimedia-constants";
import ScormXapiViewer from "../../../pages/learning-materials/components/view/ScormXapiViewer";
import {
  createCourseByAudio,
  createCourseByPDF,
  createCourseByScrom,
  createCourseByText,
  createCourseByVideo,
  createCourseByXAPI,
} from "../../../service/course-construct";
import { unitDetail } from "../../../types/course-review";
import { LearningMaterialType } from "../../../types/learning-material";
import { convertSecondsToMinutesAndSeconds } from "../../../utils/converDate";
import FileUploader from "../../file-uploader/file-uploader.component";
import FormItemDropdown from "../../form-dropdown/FormItemDropdown";
import FormInput from "../../form-input/FormInput";
import ChooseLearningMaterialModal from "../../modal/choose-learning-material/ChooseLearningMaterialModal";
import CommonModal from "../../modal/common";
import "./addLearningMaterials.scss";
import { globalStore, useAuthStore } from "../../../stores/stores";
import CustomAudioPlayer from "../../../pages/learning-materials/components/view/AudioPlayer";
import { getFirstLetter } from "../../../utils/functionUltils";
import { uploadToCloudinary } from "../../../service/common";

type Props = {
  open?: boolean;
  isLesson?: boolean;
  title?: string;
  setIsOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  id?: number;
  sequenceId?: string | number;
  handleDetail?: any;
  itemDetail?: any;
  isEdit?: boolean;
  multimediaType?: any;
  setIsEdit?: React.Dispatch<React.SetStateAction<boolean>>;
};

const optionTime = [
  {
    id: 10,
    name: "Phút",
  },
  {
    id: 20,
    name: "Giờ",
  },
];
const { TextArea } = Input;
const { Option } = Select;
const AddLearningMaterials = (props: Props) => {
  const { t } = useTranslation();
  const {
    open,
    setIsOpenDrawer,
    id,
    multimediaType,
    itemDetail,
    isEdit,
    sequenceId,
    handleDetail,
    setIsEdit,
  } = props;
  const [form] = Form.useForm();
  const blockId = itemDetail?.block?.[0]?.id;
  const type = itemDetail?.block?.[0]?.module;
  const { reload, setReload } = globalStore();
  const userInfo = useAuthStore((state) => state.user);

  const [chooseFile, setChooseFile] = useState(1);
  const [loading, setLoading] = useState(false);
  const [unitDetail, setUnitDetail] = useState<unitDetail>();
  const [fileList, setFileList] = useState<any[]>([]);
  const [fileDelete, setFileDelete] = useState<any[]>();
  const [fileUpload, setFileUpload] = useState<any>();
  const [openCornFirmModal, setOpenCornFirmModal] = useState<boolean>(false);
  const [loadingVideo, setLoadingVideo] = useState<boolean>(false);
  const [fileListMain, setFileListMain] = useState<any>([]);
  const [fileListCreate, setFileListCreate] = useState<any>([]);
  const [fileOption, setFileOption] = useState<string>("");
  const [textQuill, setTextQuill] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [isChooseLearningMaterial, setIsChooseLearningMaterial] =
    useState<boolean>(false);
  const [selectedLearningMaterial, setSelectedLearningMaterial] =
    useState<LearningMaterialType>();
  const [selectedLearningMaterialId, setSelectedLearningMaterialId] =
    useState<number>();
  const reactQuillRef = useRef<ReactQuill>(null);

  const handleChangeFileAttachment = (info: { file: any; fileList: any[] }) => {
    const deleteElm = unitDetail?.attachments.filter(
      (item1) => !info.fileList.some((item2) => item1.id === item2.id)
    );
    setFileList(info.fileList);
    setFileDelete(deleteElm);
  };
  const [iconType, setIconType] = useState<number>();

  const onUploadSuccess = (
    fileKeys: string[],
    info: { file: any; fileList: any[] }
  ) => {};

  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
    input.onchange = async () => {
      if (input !== null && input.files !== null) {
        const file = input.files[0];
        const url = await uploadToCloudinary(file, "image");
        const quill = reactQuillRef.current;
        if (quill) {
          const range = quill.getEditorSelection();
          range && quill.getEditor().insertEmbed(range.index, "image", url);
          const img = quill.getEditor().root.querySelector(`img[src="${url}"]`);
          if (img) {
            img.setAttribute(
              "style",
              `width: 150px; height: 150px; margin-bottom: 10px`
            );
            img.classList.add("custom-img-class");
          }
        }
      }
    };
  }, []);

  const videoHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "video/*, audio/mpeg");
    input.click();
    input.onchange = async () => {
      if (input !== null && input.files !== null) {
        const file = input.files[0];
        const fileType = file.type.startsWith("video/") ? "video" : "audio";

        try {
          const url = await uploadToCloudinary(file, fileType);
          const quill = reactQuillRef.current;

          if (quill) {
            const range = quill.getEditorSelection();
            if (range) {
              quill.getEditor().insertEmbed(range.index, fileType, url);
            }
          }
        } catch (err) {
          console.error("Upload failed:", err);
        }
      }
    };
  }, []);

  const MODULES_TEXT_EDITOR = {
    toolbar: {
      container: [
        [{ font: [] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        [{ header: 1 }, { header: 2 }],
        ["blockquote", "code"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: "" }, { align: "center" }, { align: "right" }],
        ["link", "image", "audio"],
      ],
      handlers: {
        image: imageHandler,
      },
    },
  };

  const onCloseDraw = () => {
    form.resetFields();
    setFileOption("");
    setFileUpload(undefined);
    setChooseFile(1);
    setFileList([]);
    setIsOpenDrawer(false);
    setFileUpload(null);
    setFileListMain([]);
    setFileListCreate([]);
    setSelectedLearningMaterial(undefined);
    if (isEdit && setIsEdit) {
      setIsEdit(false);
    }
  };
  const handleRadioChange = (e: RadioChangeEvent) => {
    setChooseFile(e.target.value);
  };
  const renderNameDraw = () => {
    return isEdit
      ? t("Sửa học liệu ", "Sửa học liệu ") + unitDetail?.title
      : t("Thêm học liệu ", "Thêm học liệu ") + renderTitle();
  };

  const returnAccept = () => {
    switch (
      multimediaType ? multimediaType?.toUpperCase() : type?.toUpperCase()
    ) {
      case "VIDEO":
        return ".mp4, .mpg, .avi, .webm, .m4v";
      case "SCORM":
        return ".zip, .rar";
      case "PDF":
        return ".pdf";
      case "AUDIO":
        return ".mp3";
      case "MP3":
        return ".mp3";
      case "TEXT":
        return ".txt";
      case "XAPI":
        return ".zip";
      default:
        break;
    }
  };

  const renderTitle = () => {
    switch (
      multimediaType ? multimediaType?.toUpperCase() : type?.toUpperCase()
    ) {
      case "VIDEO":
        return "Video";
      case "SCORM":
        return "Scorm";
      case "PDF":
        return "PDF";
      case "XAPI":
        return "xAPI";
      case "AUDIO":
        return "Audio";
      case "MP3":
        return "Audio";
      case "TEXT":
        return t("Văn bản", "Văn bản");
      case "REFERENCE":
        return t("Tài liệu tham khảo", "Tài liệu tham khảo");
      default:
        break;
    }
  };

  const getS3Prefix = () => {
    switch (
      multimediaType ? multimediaType?.toUpperCase() : type?.toUpperCase()
    ) {
      case "SCORM":
      case "XAPI":
        return "private/scorm/" + sequenceId;
      default:
        return "private/sequences/" + sequenceId;
    }
  };

  const saveScrom = async (values: any) => {
    values.attachFile?.fileList?.map((item: any) => {
      return item.originFileObj;
    });
    const sumMinute = values.minutes ? values.minutes * 60 : 0;
    const sumSecond = values.seconds ? values.seconds : 0;

    let formData: any = {};
    formData["sequenceId"] = sequenceId ?? "";
    formData["title"] = values.title;
    if (!isEmpty(values.description)) {
      formData["description"] = !isEmpty(values.description)
        ? values.description
        : "";
    }
    formData["timeCompletedCondition"] = sumMinute + sumSecond;
    formData["iconType"] = iconType;
    formData["text"] = "";
    formData["referenceUrl"] = "";
    formData["expectedTime"] = values.expectedTime;
    formData["expectedTimeType"] = values.expectedTimeType;
    formData["fileUploadFrom"] = chooseFile === 1 ? 0 : 1;

    if (!isEmpty(selectedLearningMaterial) && chooseFile === 2) {
      formData["folderId"] = selectedLearningMaterialId ?? null;
      formData["fileMain"] = selectedLearningMaterial?.rootKey ?? null;
    }

    if (!isEmpty(values.video?.fileList) && chooseFile === 1) {
      formData["fileMain"] =
        values.video?.file.response.fileKey ||
        (values.video?.fileList[0].fileKey ?? null);
    }
    if (values.videoAttach?.file) {
      formData["videoAttachment"] =
        values.videoAttach?.file.response.fileKey ||
        values.videoAttach?.file?.fileKey;
    }

    if (fileList && Array.isArray(fileList)) {
      formData["filesAttachment"] = fileList.map(
        (i) => i.response.fileKey || i.fileKey
      );
    }
    await createCourseByScrom(formData)
      .then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo học liệu scorm thành công", "Tạo học liệu scorm thành công"));
          setOpenCornFirmModal(false);
          setIsOpenDrawer(false);
          form.resetFields();
          handleDetail();
          setReload(!reload);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const saveVideo = async (values: any) => {
    values.attachFile?.fileList?.map((item: any) => {
      return item.originFileObj;
    });
    const sumMinute = values.minutes ? values.minutes * 60 : 0;
    const sumSecond = values.seconds ? values.seconds : 0;

    let formData: any = {};
    formData["sequenceId"] = sequenceId ?? "";
    formData["title"] = values.title;
    if (!isEmpty(values.description)) {
      formData["description"] = !isEmpty(values.description)
        ? values.description
        : "";
    }
    formData["timeCompletedCondition"] = sumMinute + sumSecond;
    formData["iconType"] = iconType;
    formData["text"] = "";
    formData["referenceUrl"] = "";
    formData["expectedTime"] = values.expectedTime;
    formData["expectedTimeType"] = values.expectedTimeType;
    formData["fileUploadFrom"] = chooseFile === 1 ? 0 : 1;

    if (!isEmpty(selectedLearningMaterial) && chooseFile === 2) {
      formData["folderId"] = selectedLearningMaterialId ?? null;
      formData["fileMain"] = selectedLearningMaterial?.rootKey ?? null;
    }

    if (!isEmpty(values.video?.fileList) && chooseFile === 1) {
      formData["fileMain"] =
        values.video?.file.response.fileKey ||
        (values.video?.fileList[0].fileKey ?? null);
    }
    if (values.videoAttach?.file) {
      formData["videoAttachment"] =
        values.videoAttach?.file.response.fileKey ||
        values.videoAttach?.file?.fileKey;
    }

    if (fileList && Array.isArray(fileList)) {
      formData["filesAttachment"] = fileList.map(
        (i) => i.response.fileKey || i.fileKey
      );
    }
    await createCourseByVideo(formData)
      .then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo học liệu video thành công", "Tạo học liệu video thành công"));
          setOpenCornFirmModal(false);
          setIsOpenDrawer(false);
          form.resetFields();
          handleDetail();
          setReload(!reload);
        }
      })
      .finally(() => setLoading(false));
  };

  const saveXAPI = async (values: any) => {
    values.attachFile?.fileList?.map((item: any) => {
      return item.originFileObj;
    });
    const sumMinute = values.minutes ? values.minutes * 60 : 0;
    const sumSecond = values.seconds ? values.seconds : 0;

    let formData: any = {};
    formData["sequenceId"] = sequenceId ?? "";
    formData["title"] = values.title;
    if (!isEmpty(values.description)) {
      formData["description"] = !isEmpty(values.description)
        ? values.description
        : "";
    }
    formData["timeCompletedCondition"] = sumMinute + sumSecond;
    formData["iconType"] = iconType;
    formData["text"] = "";
    formData["referenceUrl"] = "";
    formData["expectedTime"] = values.expectedTime;
    formData["expectedTimeType"] = values.expectedTimeType;
    formData["fileUploadFrom"] = chooseFile === 1 ? 0 : 1;

    if (!isEmpty(selectedLearningMaterial) && chooseFile === 2) {
      formData["folderId"] = selectedLearningMaterialId ?? null;
      formData["fileMain"] = selectedLearningMaterial?.rootKey ?? null;
    }

    if (!isEmpty(values.video?.fileList) && chooseFile === 1) {
      formData["fileMain"] =
        values.video?.file.response.fileKey ||
        (values.video?.fileList[0].fileKey ?? null);
    }
    if (values.videoAttach?.file) {
      formData["videoAttachment"] =
        values.videoAttach?.file.response.fileKey ||
        values.videoAttach?.file?.fileKey;
    }

    if (fileList && Array.isArray(fileList)) {
      formData["filesAttachment"] = fileList.map(
        (i) => i.response.fileKey || i.fileKey
      );
    }
    await createCourseByXAPI(formData)
      .then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo học liệu xAPI thành công", "Tạo học liệu xAPI thành công"));
          setOpenCornFirmModal(false);
          setIsOpenDrawer(false);
          form.resetFields();
          handleDetail();
          setReload(!reload);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const savePDF = async (values: any) => {
    values.attachFile?.fileList?.map((item: any) => {
      return item.originFileObj;
    });
    const sumMinute = values.minutes ? values.minutes * 60 : 0;
    const sumSecond = values.seconds ? values.seconds : 0;

    let formData: any = {};
    formData["sequenceId"] = sequenceId ?? "";
    formData["title"] = values.title;
    if (!isEmpty(values.description)) {
      formData["description"] = !isEmpty(values.description)
        ? values.description
        : "";
    }
    formData["timeCompletedCondition"] = sumMinute + sumSecond;
    formData["iconType"] = iconType;
    formData["text"] = "";
    formData["referenceUrl"] = "";
    formData["expectedTime"] = values.expectedTime;
    formData["expectedTimeType"] = values.expectedTimeType;
    formData["fileUploadFrom"] = chooseFile === 1 ? 0 : 1;

    if (!isEmpty(selectedLearningMaterial) && chooseFile === 2) {
      formData["folderId"] = selectedLearningMaterialId ?? null;
      formData["fileMain"] = selectedLearningMaterial?.rootKey ?? null;
    }

    if (!isEmpty(values.video?.fileList) && chooseFile === 1) {
      formData["fileMain"] =
        values.video?.file.response.fileKey ||
        (values.video?.fileList[0].fileKey ?? null);
    }
    if (values.videoAttach?.file) {
      formData["videoAttachment"] =
        values.videoAttach?.file.response.fileKey ||
        values.videoAttach?.file?.fileKey;
    }

    if (fileList && Array.isArray(fileList)) {
      formData["filesAttachment"] = fileList.map(
        (i) => i.response.fileKey || i.fileKey
      );
    }

    await createCourseByPDF(formData)
      .then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo học liệu PDF thành công", "Tạo học liệu PDF thành công"));
          setOpenCornFirmModal(false);
          setIsOpenDrawer(false);
          form.resetFields();
          handleDetail();
          setReload(!reload);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const saveAudio = async (values: any) => {
    values.attachFile?.fileList?.map((item: any) => {
      return item.originFileObj;
    });
    const sumMinute = values.minutes ? values.minutes * 60 : 0;
    const sumSecond = values.seconds ? values.seconds : 0;

    let formData: any = {};
    formData["sequenceId"] = sequenceId ?? "";
    formData["title"] = values.title;
    if (!isEmpty(values.description)) {
      formData["description"] = !isEmpty(values.description)
        ? values.description
        : "";
    }
    formData["timeCompletedCondition"] = sumMinute + sumSecond;
    formData["iconType"] = iconType;
    formData["text"] = "";
    formData["referenceUrl"] = "";
    formData["expectedTime"] = values.expectedTime;
    formData["expectedTimeType"] = values.expectedTimeType;
    formData["fileUploadFrom"] = chooseFile === 1 ? 0 : 1;

    if (!isEmpty(selectedLearningMaterial) && chooseFile === 2) {
      formData["folderId"] = selectedLearningMaterialId ?? null;
      formData["fileMain"] = selectedLearningMaterial?.rootKey ?? null;
    }

    if (!isEmpty(values.video?.fileList) && chooseFile === 1) {
      formData["fileMain"] =
        values.video?.file.response.fileKey ||
        (values.video?.fileList[0].fileKey ?? null);
    }
    if (values.videoAttach?.file) {
      formData["videoAttachment"] =
        values.videoAttach?.file.response.fileKey ||
        values.videoAttach?.file?.fileKey;
    }

    if (fileList && Array.isArray(fileList)) {
      formData["filesAttachment"] = fileList.map(
        (i) => i.response.fileKey || i.fileKey
      );
    }

    await createCourseByAudio(formData)
      .then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo học liệu mp3 thành công", "Tạo học liệu mp3 thành công"));
          setOpenCornFirmModal(false);
          setIsOpenDrawer(false);
          form.resetFields();
          handleDetail();
          setReload(!reload);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const saveText = async (values: any) => {
    values.attachFile?.fileList?.map((item: any) => {
      return item.originFileObj;
    });
    const sumMinute = values.minutes ? values.minutes * 60 : 0;
    const sumSecond = values.seconds ? values.seconds : 0;

    let formData: any = {};
    formData["sequenceId"] = sequenceId ?? "";
    formData["title"] = values.title;
    if (!isEmpty(values.description)) {
      formData["description"] = !isEmpty(values.description)
        ? values.description
        : "";
    }
    formData["timeCompletedCondition"] = sumMinute + sumSecond;
    formData["iconType"] = iconType;
    formData["text"] = values.text || selectedLearningMaterial?.text;
    formData["fileUploadFrom"] = chooseFile === 1 ? 0 : 1;

    formData["referenceUrl"] = "";
    formData["expectedTime"] = values.expectedTime;
    formData["expectedTimeType"] = values.expectedTimeType;

    if (values.videoAttach?.file) {
      formData["videoAttachment"] =
        values.videoAttach?.file.response.fileKey ||
        values.videoAttach?.file?.fileKey;
    }

    if (fileList && Array.isArray(fileList)) {
      formData["filesAttachment"] = fileList.map(
        (i) => i.response.fileKey || i.fileKey
      );
    }
    await createCourseByText(formData)
      .then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo học liệu văn bản thành công", "Tạo học liệu văn bản thành công"));
          setOpenCornFirmModal(false);
          setIsOpenDrawer(false);
          form.resetFields();
          handleDetail();
          setReload(!reload);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const editUnit = async (values: any) => {
    const sumMinute = values.minutes ? values.minutes * 60 : 0;
    const sumSecond = values.seconds ? values.seconds : 0;
    const formData: any = {};

    formData["blockId"] = String(unitDetail?.courseBlockId);
    formData["title"] = values.title;
    if (!isEmpty(values.description)) {
      formData["description"] = !isEmpty(values.description)
        ? values.description
        : "";
    }
    formData["timeCompletedCondition"] = sumMinute + sumSecond;

    if (!isEmpty(selectedLearningMaterial) && chooseFile === 2) {
      formData["folderId"] = selectedLearningMaterialId ?? null;
      formData["text"] = selectedLearningMaterial?.text ?? null;
    } else {
      formData["text"] = values.text;
    }

    formData["unitId"] = String(unitDetail?.courseUnitId);
    formData["fileMain"] = values.video || values?.selectVideo;
    formData["fileUploadFrom"] = chooseFile === 1 ? 0 : 1;

    if (!isEmpty(selectedLearningMaterial) && chooseFile === 2) {
      formData["folderId"] = selectedLearningMaterialId ?? null;
      formData["fileMain"] = selectedLearningMaterial?.rootKey ?? null;
    }

    if (!isEmpty(values.video?.fileList) && chooseFile === 1) {
      formData["fileMain"] =
        values.video?.file.response.fileKey ||
        (values.video?.fileList[0].fileKey ?? null);
    }

    const elementsWithoutId = fileList.filter(
      (item: any) => item.id === undefined || item.id === null
    );
    if (elementsWithoutId && Array.isArray(elementsWithoutId)) {
      formData["filesAttachment"] = elementsWithoutId.map(
        (i) => i.fileKey || i.response.fileKey
      );
    }
    if (fileDelete) {
      formData["filesAttachmentDelete"] =
        String(fileDelete?.map((it: any) => it.id).join(",")) ?? "";
    }

    formData["iconType"] = iconType;

    if (values.videoAttach?.file?.originFileObj) {
      formData["videoAttachment"] =
        values.videoAttach?.file?.originFileObj ?? null;
    }

    formData["expectedTime"] = values.expectedTime || null;
    formData["expectedTimeType"] = values.expectedTimeType || null;

    const apiUrl = multimediaIconList?.find(
      (it) => it.type.toLocaleLowerCase() === type.toLocaleLowerCase()
    )?.apiEdit;

    if (apiUrl) {
      await apiUrl(formData)
        .then((res: any) => {
          if (res.status === 200) {
            message.success(t("Sửa học liệu thành công", "Sửa học liệu thành công"));
            setOpenCornFirmModal(false);
            setIsOpenDrawer(false);
            form.resetFields();
            handleDetail();
            setTimeout(() => {
              setReload(!reload);
            }, 200);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    form.validateFields(["video"]);
  }, [form]);

  useEffect(() => {
    const getDetailCourseData = async () => {
      const apiUrl = multimediaIconList?.find(
        (it) => it.type.toLowerCase() === type.toLowerCase()
      )?.apiDetail;

      try {
        if (apiUrl) {
          const response = await apiUrl(blockId).then((res: any) => {
            const { data } = res.data;
            setUnitDetail(data);
            const fileList = data.attachments
              ?.filter((it: any) => it.attachmentType !== "video")
              .map((file: any) => ({
                id: file.id,
                name: file.fileName,
                status: "done",
                url: file.attachmentKey,
                attachmentType: file.attachmentType,
              }));
            setFileList(fileList);
            const objMainFileAttachment = [
              {
                uid: "-1",
                name: data.fileName,
                status: "done",
                url: data?.mainKeyUrl,
              },
            ];
            if (Number(data.fileUploadFrom !== 1)) {
              setFileListMain(objMainFileAttachment);
            }
            form.setFieldsValue({
              ...data,
              icon: isEdit
                ? unitDetail?.iconType
                : multimediaIconList?.find(
                    (it) => it.type.toLocaleLowerCase() === multimediaType
                  )?.value,
              minutes: convertSecondsToMinutesAndSeconds(
                data?.timeCompletedCondition
              )?.minutes,
              seconds: convertSecondsToMinutesAndSeconds(
                data?.timeCompletedCondition
              )?.seconds,
              videoAttach: fileList?.filter(
                (it: any) => it.attachmentType === "video"
              ),
              video:
                data.fileUploadFrom === 0
                  ? data?.mainHtmlKey || data?.mainVideo || data?.mainKey
                  : "",
              selectVideo:
                data.fileUploadFrom === 1
                  ? data?.mainHtmlKey || data?.mainVideo || data?.mainKey
                  : "",
            });
            setChooseFile(data.fileUploadFrom === 1 ? 2 : 1);
          });
        }
      } catch (error) {
      } finally {
      }
    };
    if (blockId && isEdit && open) {
      getDetailCourseData();
    }
  }, [blockId, isEdit, open]);

  useEffect(() => {
    if (unitDetail?.id && open) {
      setLoadingVideo(true);
      setFileUpload(
        unitDetail?.fileUploadFrom === 0
          ? unitDetail?.mainVideo ||
              unitDetail?.mainHtmlKey ||
              unitDetail?.mainKeyUrl
          : ""
      );
      setFileOption(
        unitDetail?.fileUploadFrom === 1
          ? unitDetail?.mainKeyUrl ||
              unitDetail?.mainVideo ||
              unitDetail?.mainHtmlKey ||
              unitDetail?.mainKey
          : ""
      );
      setTextQuill(unitDetail?.fileUploadFrom === 1 ? unitDetail?.text : "");
      setTitle(unitDetail?.title);
    }
  }, [unitDetail?.id, open]);

  const handleChangeFileUpload = (info: any) => {
    if (!isEmpty(info.fileList)) {
      setFileListMain(info.fileList);
      setFileListCreate(info.fileList);
    }
  };

  useEffect(() => {
    if (!isEmpty(fileListCreate)) {
      if (
        multimediaType !== "scorm" &&
        multimediaType !== "xAPI" &&
        type !== "scorm" &&
        type !== "xapi"
      ) {
        const videoObjectUrl = URL.createObjectURL(
          fileListCreate?.[0]?.originFileObj
        );
        if (fileListCreate?.[0]?.status === "done") {
          setFileUpload(videoObjectUrl);
          setLoadingVideo(true);
        }
      } else {
        if (fileListCreate?.[0]?.status === "done") {
          setFileUpload(fileListCreate[0]?.originFileObj);
          setLoadingVideo(true);
        }
      }
    } else {
      setFileUpload("");
    }
  }, [fileListCreate]);

  useEffect(() => {
    if (open) {
      if (isEdit) {
        setIconType(unitDetail?.iconType);
      } else {
        setIconType(
          multimediaIconList?.find(
            (item) =>
              item?.type?.toLocaleLowerCase() ===
              multimediaType?.toLocaleLowerCase()
          )?.value
        );
      }
    }
  }, [open, itemDetail, sequenceId, id]);

  const beforeUpload = () => {
    return false;
  };

  const handleSelectLearningMaterial = (data: any) => {
    setSelectedLearningMaterial(data?.units[0]);
    setSelectedLearningMaterialId(data.id);
    setIsChooseLearningMaterial(false);
  };

  const checkDisabledSaveBtn = () => {
    return (
      multimediaType !== "text" &&
      type !== "text" &&
      ((chooseFile === 1 && isEmpty(fileUpload)) ||
        isEmpty(title) ||
        (chooseFile === 2 && isEmpty(selectedLearningMaterial) && !isEdit))
    );
  };

  const renderIcon = () => {
    const iconUrl = isEdit
      ? multimediaIconList?.find((it) => it.value === unitDetail?.iconType)
          ?.iconUrl
      : multimediaIconList?.find(
          (it) => it.type.toLowerCase() === multimediaType?.toLowerCase()
        )?.iconUrl;

    return (
      <img src={iconUrl} alt="img" style={{ width: "24px", height: "24px" }} />
    );
  };

  useEffect(() => {
    if (!open) {
      form.resetFields();
      setFileUpload(null);
      setFileListMain([]);
    }
  }, [open]);

  const owner = selectedLearningMaterial?.authors.find(
    (author: any) => author.permission === "1"
  );
  return (
    <Form.Provider
      onFormFinish={async (name, { values, forms }) => {
        setLoading(true);
        setOpenCornFirmModal(false);
        if (!isEdit && itemDetail) {
          if (multimediaType === "scorm") {
            saveScrom(values);
          }
          if (multimediaType === "video") {
            saveVideo(values);
          }
          if (multimediaType === "xAPI") {
            saveXAPI(values);
          }
          if (multimediaType === "PDF") {
            savePDF(values);
          }
          if (multimediaType === "audio") {
            saveAudio(values);
          }
          if (multimediaType === "text") {
            saveText(values);
          }
        } else {
          editUnit(values);
        }
      }}
    >
      <Drawer
        title={renderNameDraw()}
        onClose={onCloseDraw}
        open={open}
        size={"large"}
        maskClosable={false}
        extra={
          <Space>
            <Button onClick={onCloseDraw} className="btn btn-outlined">
              <CloseOutlined />
              <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
            </Button>
            <Button
              className="btn btn-primary"
              // htmlType="submit"
              onClick={() => {
                setOpenCornFirmModal(true);
              }}
              loading={loading}
              disabled={checkDisabledSaveBtn()}
            >
              <SaveOutlined />
              <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
            </Button>
          </Space>
        }
      >
        <Form
          className="add-learning-materials"
          layout={"vertical"}
          form={form}
          name="add-chapter"
        >
          <>
            <Row gutter={[16, 16]}>
              <Col span={6} className="font-bold">
                {t("Thông tin chung", "Thông tin chung")}
              </Col>
              <Col span={18}>
                <Form.Item
                  label={t("Tiêu đề", "Tiêu đề")}
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: t("Thông tin này bắt buộc", "Thông tin này bắt buộc"),
                    },
                    {
                      max: 255,
                      message: t("Tiêu đề không vượt quá 255 kí tự", "Tiêu đề không vượt quá 255 kí tự"),
                    },
                  ]}
                >
                  <FormInput
                    placeholder={t("Nhập tiêu đề", "Nhập tiêu đề")}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Item>
                <Form.Item label={t("Mô tả", "Mô tả")} name="description">
                  <TextArea placeholder={t("Nhập mô tả", "Nhập mô tả")} rows={4} />
                </Form.Item>
                <div className="flex align-center gap-8">
                  <span>Icon</span>
                  {renderIcon()}
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col span={6} className="setup-time-title mt-2">
                {multimediaType === "text" || type === "text"
                  ? t("Văn bản", "Văn bản")
                  : t(" Chọn file học liệu", " Chọn file học liệu")}
              </Col>
              <Col span={18} className="learning-materials-content">
                <Col span={24}>
                  <Radio.Group value={chooseFile} onChange={handleRadioChange}>
                    <Row gutter={16}>
                      <Col>
                        <Radio value={1}>
                          <div className="choose-learning-title">
                            {multimediaType === "text" || type === "text"
                              ? t("Văn bản", "Văn bản")
                              : `${renderTitle()} từ thiết bị`}
                          </div>
                        </Radio>
                      </Col>
                      <Col>
                        <Radio value={2}>
                          <div className="choose-learning-title">
                            {renderTitle()} {t("từ thư viện", "từ thư viện")}
                          </div>
                        </Radio>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Col>

                <Col span={24}>
                  {chooseFile === 1 && (
                    <div className="add-chapter-description">
                      {multimediaType === "text" || type === "text" ? (
                        <Form.Item
                          label=""
                          name="text"
                          rules={[
                            {
                              required: true,
                              message: t("Thông tin này bắt buộc", "Thông tin này bắt buộc"),
                            },
                          ]}
                        >
                          <ReactQuill
                            ref={reactQuillRef}
                            modules={MODULES_TEXT_EDITOR}
                            theme="snow"
                            formats={FORMAT_REACT_QUILL}
                            placeholder={t("Nhập text", "Nhập text")}
                            className="add-learning-materials-popup"
                          />
                        </Form.Item>
                      ) : (
                        <>
                          {/* <div className="add-chapter-description__description">
                            <span className="text-danger">* </span>{t("Chọn một", "Chọn một")} {renderTitle()}{' '}
                            {t("từ thiết bị cá nhân của bạn", "từ thiết bị cá nhân của bạn")}
                          </div> */}

                          <Form.Item
                            name="video"
                            className="mb-0"
                            rules={[
                              {
                                required: chooseFile === 1,
                                message: t("Thông tin này bắt buộc", "Thông tin này bắt buộc"),
                              },
                            ]}
                          >
                            <FileUploader
                              beforeUpload={beforeUpload}
                              listType="picture"
                              accept={returnAccept()}
                              maxCount={1}
                              onChange={handleChangeFileUpload}
                              onRemove={() => {
                                setFileUpload(null);
                                setFileListMain([]);
                              }}
                              fileList={fileListMain}
                              prefix={getS3Prefix()}
                            >
                              <Button icon={<UploadOutlined />}>
                                {t("Tải", "Tải")} {renderTitle()}
                              </Button>
                            </FileUploader>
                          </Form.Item>

                          {/* {multimediaType === 'xAPI' && (
                            <p>{t("Vui lòng tải tệp xAPI, Dung lượng tối đa 100MB", "Vui lòng tải tệp xAPI, Dung lượng tối đa 100MB")}</p>
                          )}
                          {multimediaType === 'PDF' && (
                            <p>{t("Vui lòng tải tệp PDF, Dung lượng tối đa 100MB", "Vui lòng tải tệp PDF, Dung lượng tối đa 100MB")}</p>
                          )} */}

                          {fileUpload && loadingVideo && (
                            <>
                              {(multimediaType === "video" ||
                                type === "video") && (
                                <div className="view-unit-uploaded">
                                  <ReactPlayer
                                    url={fileUpload}
                                    controls
                                    width="100%"
                                    height="300px"
                                    style={{ marginTop: 20 }}
                                  />
                                </div>
                              )}

                              {(multimediaType === "audio" ||
                                multimediaType === "mp3" ||
                                type === "mp3") && (
                                <CustomAudioPlayer url={fileUpload} />
                              )}
                            </>
                          )}
                          {(multimediaType === "PDF" ||
                            type === "PDF" ||
                            multimediaType === "pdf" ||
                            type === "pdf") && (
                            <iframe
                              allow="fullscreen"
                              scrolling="yes"
                              width="100%"
                              height="300px"
                              src={fileUpload}
                              style={{ marginTop: 20 }}
                            />
                          )}

                          {(["scorm", "xAPI"].includes(multimediaType) ||
                            ["scorm", "xapi"].includes(type)) &&
                            fileUpload &&
                            typeof fileUpload === "string" &&
                            isEdit && (
                              <div className="view-unit-uploaded">
                                <ScormXapiViewer
                                  height="300px"
                                  src={fileUpload}
                                />
                              </div>
                            )}
                        </>
                      )}
                    </div>
                  )}

                  {chooseFile === 2 && (
                    <div className="add-chapter-description">
                      <div className="add-chapter-description__description">
                        <span className="text-danger">* </span>{t("Chọn một", "Chọn một")}{" "}
                        {renderTitle()} {t("từ thư viện", "từ thư viện")}
                      </div>
                      <Form.Item label={""} name="selectVideo">
                        <Button
                          onClick={() => setIsChooseLearningMaterial(true)}
                        >
                          {t("Chọn", "Chọn")} {renderTitle()} {t("từ thư viện", "từ thư viện")}
                        </Button>
                      </Form.Item>
                      {owner && owner?.userId !== userInfo?.id ? (
                        <div>
                          <Flex
                            gap={16}
                            align="center"
                            className="text-secondary"
                          >
                            <div className="font-bold">{t("Chủ sở hữu", "Chủ sở hữu")}</div>
                            <Flex
                              gap={16}
                              align="center"
                              className="text-secondary"
                            >
                              <Avatar
                                src={owner?.universityMemberUrl}
                                className="table-view-avatar"
                              >
                                {getFirstLetter(owner.universityMember)}
                              </Avatar>
                              <div>
                                <div className="font-weight-5">
                                  {owner?.universityMember}
                                </div>
                                <div>{owner?.name}</div>
                              </div>
                            </Flex>
                          </Flex>
                        </div>
                      ) : null}
                      {(selectedLearningMaterial ||
                        (fileOption && chooseFile === 2) ||
                        (textQuill !== "" && chooseFile === 2)) &&
                        (() => {
                          const url =
                            selectedLearningMaterial?.rootKeyUrl || fileOption;
                          const text = selectedLearningMaterial?.text || "";
                          switch (multimediaType) {
                            case "video":
                              return (
                                <div
                                  className="view-unit-uploaded"
                                  style={{ marginTop: "20px" }}
                                >
                                  <ReactPlayer
                                    url={url}
                                    controls
                                    width="100%"
                                    height="100%"
                                  />
                                </div>
                              );

                            case "pdf":
                              return (
                                <iframe
                                  allow="fullscreen"
                                  scrolling="yes"
                                  width="100%"
                                  height="100%"
                                  src={url}
                                  style={{ marginTop: "20px" }}
                                />
                              );

                            case "text":
                              return (
                                <ReactQuill
                                  ref={reactQuillRef}
                                  modules={MODULES_TEXT_EDITOR}
                                  theme="snow"
                                  formats={FORMAT_REACT_QUILL}
                                  placeholder={t("Nhập text", "Nhập text")}
                                  className="add-learning-materials-popup"
                                  value={text ? text : textQuill}
                                />
                              );

                            case "scorm":
                            case "xapi":
                            default:
                              return (
                                <div
                                  className="view-unit-uploaded"
                                  style={{ marginTop: "20px" }}
                                >
                                  <ScormXapiViewer src={url} />
                                </div>
                              );
                          }
                        })()}
                    </div>
                  )}
                </Col>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col span={6}>
                <div className="setup-time-title mt-2">{t("Chọn tệp đính kèm", "Chọn tệp đính kèm")}</div>
                {multimediaType !== "xAPI" &&
                multimediaType !== "PDF" &&
                type !== "xapi" &&
                type !== "pdf" ? (
                  <div className="describe-text">
                    Bạn có thể cung cấp cho sinh viên nội dung đính kèm cùng với
                    học liệu.
                  </div>
                ) : null}
              </Col>
              <Col span={18} className="learning-materials-content">
                <>
                  <div className="add-chapter-description">
                    <Form.Item name="attachFile">
                      <FileUploader
                        listType="picture"
                        multiple
                        beforeUpload={beforeUpload}
                        fileList={fileList}
                        prefix={getS3Prefix()}
                        onUploadSuccess={onUploadSuccess}
                        onChange={handleChangeFileAttachment}
                      >
                        <Button icon={<UploadOutlined />}>
                          {t("Tải tệp đính kèm", "Tải tệp đính kèm")}
                        </Button>
                      </FileUploader>
                    </Form.Item>
                  </div>
                </>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mt-2">
              <Col span={6}>
                <div className="setup-time-title mt-2">{t("Quy tắc hoàn thành", "Quy tắc hoàn thành")}</div>
                <div className="describe-text">
                  Đặt ra các điều kiện mà người học phải đáp ứng để hoạt động
                  học tập này được coi là 'hoàn thành'.
                </div>
              </Col>
              <Col span={18} className="learning-materials-content">
                <div className="setup-time">
                  <div className="mb-1">
                    {t("Hoạt động học này sẽ được coi là hoàn thành khi người học:", "Hoạt động học này sẽ được coi là hoàn thành khi người học:")}
                  </div>
                  <div className="setup-time-time">
                    <div>
                      <span className="setup-time-title pe">{t("Phút", "Phút")}</span>
                      <Form.Item name="minutes">
                        <InputNumber
                          min={0}
                          max={60}
                          changeOnWheel
                          placeholder={t("Chọn phút", "Chọn phút")}
                        />
                      </Form.Item>
                    </div>
                    <div>
                      <span className="setup-time-title pe">{t("Giây", "Giây")}</span>
                      <Form.Item name="seconds">
                        <InputNumber
                          min={0}
                          max={59}
                          changeOnWheel
                          placeholder={t("Chọn giây", "Chọn giây")}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mt-2">
              <Col span={6}>
                <div className="expected-time-title">{t("Nỗ lực mong chờ", "Nỗ lực mong chờ")}</div>
              </Col>
              <Col span={12}>
                <Row gutter={16}>
                  <Col span={10}>
                    <Form.Item name="expectedTime">
                      <InputNumber style={{ width: "100%" }} min={1} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="expectedTimeType">
                      <FormItemDropdown
                        style={{ width: "100%" }}
                        options={optionTime}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>

          <CommonModal
            open={openCornFirmModal}
            title={t("Thông báo xác nhận lưu học liệu", "Thông báo xác nhận lưu học liệu")}
            desc={
              <>
                <p>{t("Xin vui lòng xác nhận việc lưu học liệu trong khoá học", "Xin vui lòng xác nhận việc lưu học liệu trong khoá học")}</p>
                <div>
                  {t("Đảm bảo rằng tất cả các", "Đảm bảo rằng tất cả các")}{" "}
                  <span className="text-browse">
                    {t("thông tin liên quan đã được kiểm tra và cập nhật đầy đủ", "thông tin liên quan đã được kiểm tra và cập nhật đầy đủ")}{" "}
                  </span>
                  {t("trước khi lưu khoá học", "trước khi lưu khoá học")}
                </div>
              </>
            }
            closeIcon={true}
            okText={t("Xác nhận", "Xác nhận")}
            cancelText={t("Huỷ", "Huỷ")}
            icon={
              <InfoCircleOutlined
                style={{ color: "#FFC53D", marginRight: "10px" }}
              />
            }
            confirm={form.submit}
            closeModal={() => setOpenCornFirmModal(false)}
          />
        </Form>
      </Drawer>

      <ChooseLearningMaterialModal
        open={isChooseLearningMaterial}
        type={multimediaType ? multimediaType : type}
        onSelectLearningMaterial={handleSelectLearningMaterial}
        onCancel={() => setIsChooseLearningMaterial(false)}
      />
    </Form.Provider>
  );
};

export default AddLearningMaterials;

interface ItemDetail {
  name: string;
  describe: string;
  id: number;
  video: any;
  block: any;
}